export const coreAddresses = {
  balanceTracker: "0x05d14f4eDFA7Cbfb90711C2EC5505bcbd49b9cD2",
  eVaultFactory: "0xcF5552580fD364cdBBFcB5Ae345f75674c59273A",
  eVaultImplementation: "0x05de079A28386135E048369cdf0Bc4D326d5EBDF",
  eulerEarnFactory: "0x587DD8285c01526769aB4803e4F02433ddbBc00E",
  evc: "0xceAA7cdCD7dDBee8601127a9Abb17A974d613db4",
  permit2: "0x000000000022D473030F116dDEE9F6B43aC78BA3",
  protocolConfig: "0x43144f09896F8759DE2ec6D777391B9F05A51128",
  sequenceRegistry: "0x47618E4CBDcFBf5f21D6594A7e3a4f4683719994",
} as const
